import { render, staticRenderFns } from "./AccountDeletionPage.vue?vue&type=template&id=d597a5d8&scoped=true&"
import script from "./AccountDeletionPage.vue?vue&type=script&lang=js&"
export * from "./AccountDeletionPage.vue?vue&type=script&lang=js&"
import style0 from "./AccountDeletionPage.vue?vue&type=style&index=0&id=d597a5d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d597a5d8",
  null
  
)

export default component.exports